"use client";

import React from "react";
import { LocaleLink as Link } from "@/components/shared/LocaleLink";
import { useTranslations } from "@/lib/i18n-client";
import { Reveal } from "@/components/shared/motion";
import { ArrowRight, Sparkles } from "lucide-react";

/**
 * AquaGlobe CTA band — a full-width teal->lavender gradient glass band with
 * white text and a white glass pill CTA routing to /destinations/. Glass-native.
 */
export default function CtaBand() {
  const { t } = useTranslations();

  return (
    <section className="container mx-auto px-4 py-12">
      <Reveal as="div" className="aqua-gradient relative overflow-hidden rounded-3xl p-8 sm:p-12 text-white shadow-xl flex flex-col sm:flex-row items-center justify-between gap-6" y={20}>
        <Sparkles className="absolute -top-4 -right-2 h-24 w-24 text-white/15" aria-hidden="true" />
        <div className="relative">
          <h2 className="text-2xl sm:text-3xl font-bold">
            {t("aqua.cta.title", "Ready to travel connected?")}
          </h2>
          <p className="mt-2 text-white/90 max-w-lg">
            {t("aqua.cta.sub", "Choose your destination, check out securely, and get your eSIM QR code instantly.")}
          </p>
        </div>
        <Link
          href="/destinations/"
          className="relative inline-flex items-center gap-2 rounded-full bg-white text-primary font-bold px-7 h-12 shrink-0 shadow-lg hover:bg-white/90 transition-all active:scale-[0.98]"
        >
          {t("aqua.cta.button", "Browse destinations")} <ArrowRight className="h-4 w-4" />
        </Link>
      </Reveal>
    </section>
  );
}
